import { render, staticRenderFns } from "./Rgpd.vue?vue&type=template&id=515cbf1a&scoped=true&"
import script from "./Rgpd.vue?vue&type=script&lang=js&"
export * from "./Rgpd.vue?vue&type=script&lang=js&"
import style0 from "./Rgpd.vue?vue&type=style&index=0&id=515cbf1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515cbf1a",
  null
  
)

export default component.exports